jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});
 $( document ).on( "variant:changed", function( evt ) {
         var preorderStatus = document.querySelector('[data-preorder-status]');
	   console.log('----------',window.getComputedStyle(preorderStatus).display);
	   });

// document.querySelectorAll('.t4s-swatch__item').forEach(item => {
//     item.addEventListener('click', event => {
//         setTimeout(() => {
//             var expressDeliveryTag = document.querySelector('.express_delivery_tag');
//             var deliveryTextElements = document.querySelectorAll('.delivery--text');
//             deliveryTextElements.forEach(function(element) {
//                 var preorderStatus = document.querySelector('[data-preorder-status]');
// console.log('----------1',window.getComputedStyle(preorderStatus).display);
//                 if (preorderStatus && window.getComputedStyle(preorderStatus).display !== 'none') {
//                     element.textContent = '20-23 working days';
//                     if (expressDeliveryTag) {
//                         expressDeliveryTag.style.display = 'none';
//                     }
//                 } else {
//                     element.textContent = '5-6 working days';
//                     if (expressDeliveryTag) {
//                         expressDeliveryTag.style.display = 'inline-block';
//                     }
//                 }
//             });
//         }, 500);
//     });
// });


// Function to check the submit button and update delivery text
function checkSubmitButtonAndUpdateDelivery() {
    var expressDeliveryTag = document.querySelector('.express_delivery_tag');
    var deliveryTextElements = document.querySelectorAll('.delivery--text');
    
    deliveryTextElements.forEach(function(element) {
        var preorderStatus = document.querySelector('[data-preorder-status]');
        console.log('----------1', window.getComputedStyle(preorderStatus).display);

        // Check if the .t4s-product-form__submit button is disabled
        var submitButton = document.querySelector('.t4s-product-form__submit');
        var isSubmitDisabled = submitButton && submitButton.disabled;

        if (preorderStatus && window.getComputedStyle(preorderStatus).display !== 'none') {
            element.textContent = '12-15 working days';
            if (expressDeliveryTag) {
                expressDeliveryTag.style.display = 'none';
            }
        } else if (!isSubmitDisabled) {
            element.textContent = '5-6 working days';
            if (expressDeliveryTag) {
                expressDeliveryTag.style.display = 'inline-block';
            }
        } else {
            element.textContent = 'Unavailable';
            if (expressDeliveryTag) {
                expressDeliveryTag.style.display = 'none';
            }
        }
    });
}

// Check when swatch items are clicked
document.querySelectorAll('.t4s-swatch__item').forEach(item => {
    item.addEventListener('click', event => {
        setTimeout(() => {
            checkSubmitButtonAndUpdateDelivery();
        }, 500);
    });
});

// Check on page load
window.addEventListener('load', () => {
    checkSubmitButtonAndUpdateDelivery();
});

